<button (click)="toggle()" [ngClass]="getFilterClasses()">
  <p [ngClass]="getFilterTextClasses()" class="custom-base-color">
    {{ 'filters.' + filter.name | translate }}
  </p>
</button>
